import script from "./NavigateBack.vue?vue&type=script&setup=true&lang=ts"
export * from "./NavigateBack.vue?vue&type=script&setup=true&lang=ts"

import "./NavigateBack.vue?vue&type=style&index=0&id=dcae3aa8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dcae3aa8"]])

export default __exports__